export default __webpack_public_path__ + "static/media/600.ec58f8f4.woff";